export const VisitorStatus = ({ status }) => {
    let result;
    switch (status) {
        case 0: result = <span className="text-nowrap bg-info text-light p-1 rounded">Ожидаем</span>;
            break;
        case 1: result = <span className="text-nowrap bg-success text-light p-1 rounded">На месте</span>;
            break;
        case 2: result = <span className="text-nowrap bg-secondary text-light p-1 rounded">Сдал тест</span>;
            break;
        case 3: result = <span className="text-nowrap bg-success text-light p-1 rounded">Вход разрешен</span>;
            break;
        case 4: result = <span className="text-nowrap bg-danger text-light p-1 rounded">Вход запрещен</span>;
            break;
        case 5: result = <span className="text-nowrap bg-success text-light p-1 rounded">Заказ выдан</span>;
            break;
        default: result = <span>Некорректные данные</span>
    }
    return result;
}